module.exports = __webpack_public_path__ + "static/media/mca-architects.664975d5.png";